export function addClassToElement(element: Element, className: string): Element {
    element.setAttribute('class', element.getAttribute('class') + ' ' + className);
    return element;
}
